import React, { useState } from 'react';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import ImageViewer from './ImageViewer';
import { useLanguage } from '@/context/LanguageContext';
interface ExhibitImageProps {
  images: string[];
  alt: string;
}

const ExhibitImage = ({ images, alt }: ExhibitImageProps) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const { dir } = useLanguage();

  const handleImageClick = (index: number) => {
    setSelectedImageIndex(index);
    setIsViewerOpen(true);
  };

  return (
    <>
      <AspectRatio ratio={4/3} className="w-full">
        <div className="relative w-full h-full bg-gray-100 overflow-hidden rounded-xl">
          <Carousel className="w-full h-full" opts={{ direction: dir }}>
            <CarouselContent className="h-full">
              {images.map((image, index) => (
                <CarouselItem key={index} className="h-full flex justify-center items-center">
                  <img 
                    src={image} 
                    alt={`${alt} - image ${index + 1}`} 
                    className="w-full h-full object-contain cursor-pointer hover:opacity-90 transition-opacity"
                    onClick={() => handleImageClick(index)}
                  />
                </CarouselItem>
              ))}
            </CarouselContent>
            {images.length > 1 && (
              <>
                <CarouselPrevious className="left-2 z-10" />
                <CarouselNext className="right-2 z-10" />
              </>
            )}
          </Carousel>
        </div>
      </AspectRatio>

      <ImageViewer
        images={images}
        initialIndex={selectedImageIndex}
        isOpen={isViewerOpen}
        onClose={() => setIsViewerOpen(false)}
        alt={alt}
      />
    </>
  );
};

export default ExhibitImage;
